import HSBB2 from './hsbb-sdk-v2';
import { getToken } from './utility';

const baseURL = process.env.REACT_APP_API_URL_V2;

const HSBBClientV2 = new HSBB2({ baseURL, getToken });

export default HSBBClientV2;
